import { useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { useRoles } from '@/lib/useRoles';

const navItems = [
  { to: '/', label: 'Início', icon: 'ri-home-5-line', end: true },
  { to: '/loads', label: 'Cargas', icon: 'ri-truck-line' },
];

function Logo() {
  return (
    <div className="flex items-center gap-2">
      <span className="grid h-9 w-9 place-items-center rounded-lg bg-primary text-white">
        <i className="ri-route-line text-lg" />
      </span>
      <span className="text-base font-semibold tracking-tight">Portal Parceiros</span>
    </div>
  );
}

export default function AppLayout() {
  const { roles } = useRoles();
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();
  const isBoard = pathname === '/loads';

  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-20 border-b bg-card px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-3">
          <Logo />
          <div className="hidden gap-1 md:flex">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium whitespace-nowrap ${
                    isActive ? 'bg-muted text-foreground' : 'text-muted-foreground hover:bg-muted'
                  }`
                }
              >
                <i className={item.icon} />
                {item.label}
              </NavLink>
            ))}
          </div>
          <div className="hidden items-center gap-2 md:flex">
            {roles.slice(0, 2).map((r) => (
              <span
                key={r}
                className="rounded-full bg-muted px-2.5 py-0.5 text-xs font-medium text-muted-foreground"
              >
                {r}
              </span>
            ))}
            <NavLink to="/login" className="cursor-pointer text-sm text-foreground-600 hover:text-primary-700">Conta</NavLink>
            <button
              onClick={() => supabase.auth.signOut()}
              className="cursor-pointer rounded-md px-3 py-2 text-sm font-medium hover:bg-muted"
            >
              <i className="ri-logout-box-r-line" /> Sair
            </button>
          </div>
          <button
            className="grid h-10 w-10 place-items-center rounded-md hover:bg-muted md:hidden"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu"
            aria-expanded={mobileOpen}
            aria-controls="mobile-navigation"
          >
            <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
        {mobileOpen && (
          <nav id="mobile-navigation" className="flex flex-wrap gap-2 border-t py-3 md:hidden" aria-label="Navegação móvel">
            {navItems.map((item) => <NavLink key={item.to} to={item.to} end={item.end} onClick={() => setMobileOpen(false)} className="cursor-pointer rounded-md px-3 py-2 text-sm hover:bg-background-100">{item.label}</NavLink>)}
            <NavLink to="/login" onClick={() => setMobileOpen(false)} className="cursor-pointer rounded-md px-3 py-2 text-sm hover:bg-background-100">Conta</NavLink>
          </nav>
        )}
      </header>
      <main className={isBoard ? 'w-full px-4 py-6 md:px-6' : 'mx-auto max-w-7xl px-4 py-8 md:px-6'}>
        <Outlet />
      </main>
    </div>
  );
}